import styled from "styled-components"

//  Data Table Styles
export const CenterAlignedText = styled.div`
text-align: center;
`